import { useFormState } from '@graphcommerce/ecommerce-ui'
import { ApolloCartErrorSnackbar } from '@graphcommerce/magento-cart'
import {
  Button,
  ErrorSnackbar,
  ErrorSnackbarProps,
  filterNonNullableKeys,
  iconChevronRight,
  IconSvg,
  MessageSnackbar,
  MessageSnackbarProps,
} from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { toUserErrors } from './toUserErrors'
import { useFormAddProductsToCart } from './useFormAddProductsToCart'

export type AddProductsToCartSnackbarProps = {
  errorSnackbar?: Omit<ErrorSnackbarProps, 'open'>
  successSnackbar?: Omit<MessageSnackbarProps, 'open' | 'action'>
}

export function AddProductsToCartSnackbar(props: AddProductsToCartSnackbarProps) {
  const { errorSnackbar, successSnackbar } = props
  const { error, data, redirect, control } = useFormAddProductsToCart()
  const formState = useFormState({ control })

  const userErrors = toUserErrors(data)

  const showSuccess =
    !formState.isSubmitting &&
    formState.isSubmitSuccessful &&
    !error?.message &&
    !userErrors.length &&
    !redirect

  const items = filterNonNullableKeys(data?.addProductsToCart?.cart.items)

  const showErrorSnackbar = userErrors.length > 0

  const parseErrorMessage = (errorMessage?: string) => {
    console.log({errorMessage})
    if(!errorMessage) return ""
    if (String(errorMessage).includes("fewest")) {
      const fewestPurchase = errorMessage.match(/\d+/)[0];
      return`La quantita minima acquistabile è ${fewestPurchase}.`;
    }
    if (String(errorMessage).includes("choose")) {
      return "Seleziona una combinazione di opzioni per procedere all’acquisto.";
    }
    if (String(errorMessage).includes("available")) {
      return "Siamo spiacenti, il prodotto non è disponibile";
    }
    if(String(errorMessage).includes("at a time")){
      const minimumIncrement = errorMessage.match(/\d+/)[0];
      return `Questo prodotto è venduto in confezioni da ${minimumIncrement}.`;
    }
    return errorMessage
  }

  return (
    <>
      {error && <ApolloCartErrorSnackbar error={error} />}

      {showErrorSnackbar && (
        <ErrorSnackbar variant='pill' severity='error' {...errorSnackbar} open={showErrorSnackbar}>
          <>{parseErrorMessage(data?.addProductsToCart?.user_errors?.map((e) => e?.message).join(', '))}</>
        </ErrorSnackbar>
      )}

      {showSuccess && (
        <MessageSnackbar
          variant='pill'
          {...successSnackbar}
          open={showSuccess}
          action={
            <Button
              href='/cart'
              id='view-shopping-cart-button'
              size='medium'
              variant='pill'
              color='secondary'
              endIcon={<IconSvg src={iconChevronRight} />}
              sx={{ display: 'flex' }}
            >
              <Trans id='View shopping cart' />
            </Button>
          }
        >
          <Trans
            id='<0>{name}</0> has been added to your shopping cart!'
            components={{ 0: <strong /> }}
            values={{ name: items[items.length - 1]?.product.name }}
          />
        </MessageSnackbar>
      )}
    </>
  )
}
